module.exports = __webpack_public_path__ + "static/media/15_contact_book.53730893.png";